import SpecificationInterface from './specification-interface';

class DisabledPlayerIfGameLockedSpecification implements SpecificationInterface {
    isSatisfiedBy(params: object): boolean {
        // @ts-ignore
        const {sportConfig, games, player} = params;

        return (
            sportConfig !== undefined &&
            sportConfig.isModeLateswap() &&
            sportConfig.isGameTypeClassic() &&
            games.isPlayerGameLocked(player)
        );
    }
}

export default new DisabledPlayerIfGameLockedSpecification();
